(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('AsistenteAuditoriaCtrl', AsistenteAuditoriaController);

  AsistenteAuditoriaController.$inject = [
    'LoadingService',
    '$q',
    'MessagesService',
    '$scope',
    'aplicacoes',
    'RecomendacoesService',
    'UnidadesService',
    'AssistenteAuditoriaService',
    '$route'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function AsistenteAuditoriaController(LoadingService,
    $q, MessagesService, $scope, aplicacoes,
    RecomendacoesService, UnidadesService,
    AssistenteAuditoriaService, $route) {
    const vm = this;
    const SELECAO_INSUMOS = 2;
    const SELECAO_GLEBAS = 3;
    //Model
    vm.currentStep = 1;
    vm.working = false;
    vm.items = null;
    vm.currentIndex = 0;
    vm.steps = [
      {
        step: 1,
        name: 'Seleção',
        enable: true,
        template: 'views/painel_propriedade/aplicacao/wizard/step1.html'
      },
      {
        step: 2,
        name: 'Substituição',
        enable: false,
        template: 'views/painel_propriedade/aplicacao/wizard/step2.html'
      },
      {
        step: 3,
        name: 'Talhões',
        enable: false,
        template: 'views/painel_propriedade/aplicacao/wizard/step3.html'
      }
    ];

    vm.insumos = [];
    vm.insumosSelecionados = [];
    vm.newItem;
    vm.aplicacoes = aplicacoes;

    //////////////////////////////////////////
    // Bindable functions
    vm.goToStep = goToStep;
    vm.getStepTemplate = getStepTemplate;
    vm.save = save;
    vm.searchItems = searchItems;
    vm.addItem = addItem;

    //////////////////////////////////////////
    // Function declarations
    // eslint-disable-next-line max-lines-per-function
    function initialize() {
      // eslint-disable-next-line max-lines-per-function
      vm.aplicacoes.forEach((aplicacao) => {
        // eslint-disable-next-line max-lines-per-function
        aplicacao.produtos.forEach((produto) => {
          const item = {
            item_id: produto.item_id || produto.cd_item,
            tipo_id: produto.tipo_id || produto.cd_tipo,
            descricao: produto.descricao,
            unidade: produto.unidade,
            unidadesCompativeis: produto.unidadesCompativeis || UnidadesService.getUnidadesCompativeis(produto.unidade)
          };

          if (!aplicacao.gleba.id) {
            aplicacao.gleba.id = aplicacao.id;
            aplicacao.gleba.descricao = aplicacao.sementes.origem.descricao;
          }

          let newInsumo = vm.insumos.find((insumo) => insumo.insumo_was.item_id === item.item_id);
          if (newInsumo) {
            const newGleba = newInsumo.glebas.find((gleba) => gleba.gleba.id === aplicacao.gleba.id);
            if (newGleba) {
              newGleba.aplicacoes.push(aplicacao.id);
            } else {
              newInsumo.glebas.push({
                gleba: aplicacao.gleba,
                aplicacoes: [aplicacao.id]
              });
            }
          } else {
            newInsumo = {
              insumo_was: item,
              insumo: null,
              glebas: [{
                gleba: aplicacao.gleba,
                aplicacoes: [aplicacao.id]
              }],
              selecionado: false
            };
            vm.insumos.push(newInsumo);
          }

          const iteratees = (obj) => obj.insumo_was.descricao;
          vm.insumos = _.sortBy(vm.insumos, iteratees);
        });
      });
    }

    function getStep() {
      for (let i = 0; i < vm.steps.length; i++) {
        if (vm.currentStep === vm.steps[i].step) {
          return vm.steps[i];
        }
      }
    }

    function getSelected() {
      vm.insumosSelecionados = _.filter(vm.insumos, { selecionado: true });
    }

    function searchItems($select, index) {
      vm.searchItem = $select.search;
      vm.items = null;
      vm.currentIndex = index;
      if (vm.searchItem.length >= 3) {
        vm.insumosSelecionados[index].loadingItems = true;
        RecomendacoesService.listItemsBalance({
          descricao: $select.search
        }, null).then(function(data) {
          let result = data.data || [];
          result = result.map((item) => {
            item.item_id = item.id;
            item.tipo_id = item.tipo;
            return item;
          });
          vm.items = result.filter((item) => vm.insumosSelecionados[index].insumo_was.item_id !== item.item_id);
        })
          .catch(function(error) {
            console.error('Erro ao buscar produtos', error);
            MessagesService.alert('Erro ao carregar produtos');
          })
          .finally(function() {
            vm.insumosSelecionados[index].loadingItems = false;
          });
      }
    }


    function addItem(item, index) {
      if (item) {
        //para encontrar a unidade pelo ID da WEB e não da API
        item.unidade.nomeSistema = item.unidade.nomeSistema || item.unidade.descricao;

        let unidade = UnidadesService.getMeasureUnitysFromDescription(item.unidade.descricao);
        if (_.isEmpty(unidade)) {
          unidade = item.unidade;
        }
        const unidadesCompativeis = UnidadesService.getUnidadesCompativeis(unidade);

        const insumo = vm.insumosSelecionados[index];
        const newItem = {
          item_id: item.item_id,
          tipo_id: item.tipo_id,
          descricao: item.descricao,
          unidade: item.unidade,
          unidadesCompativeis: unidadesCompativeis
        };

        insumo.insumo = newItem;
      }
    }

    initialize();

    //////////////////////////////////////////
    // Controller data
    function goToStep(newStep) {
      if (newStep === SELECAO_INSUMOS) {
        getSelected();
      }
      let selecionados = vm.insumosSelecionados;

      if (newStep === SELECAO_GLEBAS) {
        selecionados = vm.insumosSelecionados
          .filter((insumo) => insumo.insumo);
        selecionados.forEach((insumo) => {
          insumo.glebas.forEach((gleba) => gleba.selecionado = insumo.glebas.length === 1);
        });
      }

      if (selecionados.length) {
        vm.insumosSelecionados = selecionados;
        vm.currentStep = newStep;
      }
    }

    function getStepTemplate() {
      return getStep().template;
    }

    function save() {
      LoadingService.showLoading();
      vm.working = true;
      AssistenteAuditoriaService.batchInsumos(vm.insumosSelecionados).then(function() {
        LoadingService.hideLoading();
        MessagesService.alert('Finalizado com sucesso!');
        $scope.$close(true);
        $scope.$emit(EVENT_RELOAD_NOTIFICATIONS);
        $route.reload();
        vm.working = false;
      }, function(error) {
        console.error('Erro ao enviar dados para API', error);
        LoadingService.hideLoading();
        vm.working = false;
        let message = 'Ocorreu um erro ao tentar fazer as substituições dos insumos!';
        message = `${message} <br> ${error.data}`;
        MessagesService.alert(message);
      })
        .finally(LoadingService.hideLoading);
    }
  }
}());
